"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.15 15.004a3.44 3.44 0 0 0-3.442 3.442.7.7 0 1 1-1.4 0 4.84 4.84 0 0 1 4.842-4.842h1.86a.7.7 0 1 1 0 1.4zm1.702-8.75a2.456 2.456 0 1 1 0 4.912 2.456 2.456 0 0 1 0-4.912m3.856 2.456a3.856 3.856 0 1 0-7.712 0 3.856 3.856 0 0 0 7.712 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.71 10.066a2.2 2.2 0 0 1 3.112 0l.226.226a2.2 2.2 0 0 1 0 3.111l-5.153 5.154a1.2 1.2 0 0 1-.708.343l-1.861.22a1.2 1.2 0 0 1-1.333-1.332l.22-1.861a1.2 1.2 0 0 1 .344-.708zm2.122.99a.8.8 0 0 0-1.132 0l-5.104 5.104-.183 1.54 1.54-.182 5.105-5.104a.8.8 0 0 0 0-1.132z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserWithPencil24.js.map